export default __webpack_public_path__ + "static/media/26.1c945583.jpg";